import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { CustomerSucessController } from "@talentbait/shared-components";
import { Link } from "react-router-dom";
import { SignOutIcon, CheckedIcon, AddIcon } from "./Previews/Svg/index.js";
import { getSecondsLeft } from "./Previews/utils.js";
import { DEFAULT_MINUTES_LEFT_TO_START } from "./Previews/constants.js";
import { withRefluxStore, StatusStore } from "../../Stores/index.js";
import CampaignCreateStartDateEditor from "./Previews/Campaign__Create_StartDateEditor.jsx";
import Actions from "../../Actions.js";
import logger from "../../utils/LoggerFrontend.js";
import { useTranslation } from "react-i18next";

const FinishedWrapper = styled.div`
  max-width: 864px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  font-family: Public Sans;
`;
const BackgroundImage = styled.img`
  position: absolute;
  width: 310px;
  left: 0;
  top: 65px;
  z-index: -1;
`;
const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  color: #999999;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
`;
const DashboardLink = styled(Link)`
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.2s;
  color: #999999;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    background-color: #99999910;
  }
  svg {
    margin-left: 4px;
    margin-bottom: 1px;
  }
`;
const GratitudeWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #5f5c70;
  font-weight: 700;
  font-size: 18px;
  margin: 130px 0 50px;
`;
const CheckedIconWrapper = styled.div`
  margin-right: 16px;
  height: 40px;
  width: 40px;
  color: #22c380;
  border-radius: 100%;
  border: 2px solid #22c380;
  padding: 4px;
`;
const Panel = styled.div`
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #f1f0f5;
  width: 100%;
  margin-bottom: 16px;
`;
const PanelConent = styled.div`
  padding: 16px;
  text-align: left;
`;
const PhonesPicture = styled.img`
  width: 100%;
`;
const PanelInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;
const PanelTitle = styled.div`
  font-weight: 700;
  color: #928fa3;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
`;
const PanelDescription = styled.div`
  font-weight: 400;
  color: #302e38;
  font-size: 18px;
  line-height: 24px;
`;
const PreviewLink = styled(Link)`
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.2s;
  color: #fff;
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1e22ff;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  width: 200px;
  &:hover {
    color: #fff;
    background-color: #171ac1;
  }
`;
const CreateNewCampaignLink = styled(Link)`
  width: 100%;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.2s;
  color: #5f5c70;
  padding: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f1f0f5;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  &:hover {
    color: #5f5c70;
    background-color: #dddce1;
  }
  svg {
    margin-right: 8px;
    margin-bottom: 1px;
  }
`;

const CampaignAgencyFinished = ({
  orgaId,
  campaignId,
  createdDate,
  startDate,
  userProfile,
  adsetId
}) => {
  const { t } = useTranslation();

  const [startingDate, setStartingDate] = useState(() =>
    startDate
      ? new Date(startDate)
      : new Date(new Date(createdDate).getTime() + DEFAULT_MINUTES_LEFT_TO_START * 60000)
  );
  const [status, setStatus] = useState("SCHEDULED");

  const changeStartingDate = useCallback(
    (dateTimePickerValue) => {
      setStartingDate(dateTimePickerValue);
      Actions.changeCampaignData(
        orgaId,
        campaignId,
        "startDate",
        dateTimePickerValue.toISOString()
      );
    },
    [setStartingDate, orgaId, campaignId]
  );

  const [secondsLeft, setSecondsLeft] = useState(() => {
    const currentDateObj = new Date();
    return startingDate.getTime() < currentDateObj.getTime()
      ? 0
      : getSecondsLeft(startingDate, currentDateObj);
  });

  const setCampaignWaitingForApproval = useCallback(() => {
    logger.log("CampaignAgencyFinished", "setCampaignWaitingForApproval", {
      campaignId,
      userProfile
    });
    Actions.updateCampaignStatus(campaignId, "WAITING_FOR_APPROVAL", userProfile.userName, false);
    Actions.deleteCampaignField(campaignId, "startDate");
    setStatus("WAITING_FOR_APPROVAL");
    setSecondsLeft(0);
  }, [campaignId, userProfile]);

  // This event was sent in the previous version - no idea what its for
  useEffect(() => {
    CustomerSucessController.send(`NewAgencyCampaign:Finished`);
  }, []);

  return (
    <FinishedWrapper>
      <BackgroundImage src="/images/CampaignFinishBackground.png" alt="" />
      <HeaderWrapper>
        <div>{t("Booking confirmation")}</div>
        <DashboardLink to="/dashboard">
          {t("Back to Dashboard")}
          <SignOutIcon />
        </DashboardLink>
      </HeaderWrapper>
      <GratitudeWrapper>
        <CheckedIconWrapper>
          <CheckedIcon />
        </CheckedIconWrapper>
        {t("Thank you for your booking!")}
      </GratitudeWrapper>
      <Panel>
        <PhonesPicture src="/images/CampaignFinishPhones.png" alt="" />
        <PanelConent>
          <PanelTitle>{t("Ad preview")}</PanelTitle>
          <PanelInfo>
            <PanelDescription>
              {t("Here you can find the ad previews for all booked channels")}
            </PanelDescription>
            <PreviewLink to={`/creatives/${campaignId}/${adsetId}`}>{t("Ad preview")}</PreviewLink>
          </PanelInfo>
        </PanelConent>
      </Panel>
      {status == "SCHEDULED" && secondsLeft !== 0 && (
        <Panel>
          <PanelConent>
            <PanelTitle>Vorausplanen</PanelTitle>
            <CampaignCreateStartDateEditor
              textBeforeTime={t("Your campaign goes into")}
              textAfterTime={t(
                "live. Do you want to change something or need support from a campaign manager?"
              )}
              startingDate={startingDate}
              changeStartingDate={changeStartingDate}
              secondsLeft={secondsLeft}
              setSecondsLeft={setSecondsLeft}
              setCampaignWaitingForApproval={setCampaignWaitingForApproval}
            />
          </PanelConent>
        </Panel>
      )}
      <CreateNewCampaignLink to="/new-campaign" target="_blank">
        <AddIcon /> {t("Book a new campaign")}
      </CreateNewCampaignLink>
    </FinishedWrapper>
  );
};

export default withRefluxStore(CampaignAgencyFinished, [StatusStore]);
